<template>
  <div id="LetsCss">
    <template v-if="$route.query && $route.query.hideTemplate">
      <div>
        <VAppBar app dark color="primary" >
          <VToolbarTitle>{{ getAppHeaderTitle ?? $route.name }}</VToolbarTitle>
        </VAppBar>
        <VMain>
          <RouterView />
        </VMain>
      </div>
    </template>
    <template v-else>
      <BaseAdminTemplate
        :sidebar-list="filtedSidebarList"
        v-bind="{
          footerText
        }"
      >
        <template #RightContent>
          {{getUser.user_named}}
          <!-- <ChangeLanguageBtn /> -->
        </template>
      </BaseAdminTemplate>
    </template>
  </div>
</template>

<script>
import BaseAdminTemplate from './BaseAdminTemplate.vue'
import { mapGetters, mapState } from 'vuex';
import moment from 'moment';
export default {
  components: { BaseAdminTemplate },
  data () {
    return {
    }
  },
  computed:{
    ...mapGetters('Auth', [
      'getUser',
      'isStudent',
      'getUserAuthorityFunctionIDs',
      'getFilteredAuthorityFunctionIDs',
      'getUserDisabledRouteNames',
    ]),
    ...mapState('Auth', ['menu']),
    footerText(){
      return `© ${moment().year()} オンライン家庭教師WAM`
    },
    mainSidebarList(){
      return  [
        {
          title: 'TOP',
          items: [
            {
              title: 'お知らせ',
              to: { name: 'C00101' },
              functionId: 'C00101',
            },
            {
              title: 'アラート',
              to: { name: 'C00102' },
              functionId: 'C00102',
            },
          ]
        },
        {
          title: '生徒関連',
          items: [
            {
              title: '生徒カルテ',
              to: { name: 'C20201Browse' },
              functionId: 'C20201',
            },
            {
              title: '生徒情報',
              to: { name: 'C20101Browse' },
              functionId: 'C20101',
            },
            {
              title: '要望一覧',
              to: { name: 'C40411Browse' },
              functionId: 'C40411',
            },
            {
              title: 'アドバンス',
              to: { name: 'C40421Browse' },
              functionId: 'C40421',
              show: this.$store.state.Auth.DB_getConfigs.T1037StudentHandleImage.feature_enabled === '1'
            },
            {
              title: '生徒担当センター変更',
              to: { name: 'C20301Browse' },
              functionId: 'C20301',
            },
            {
              title: '退会・休会・取り消し',
              // to: { name: 'C20301Browse' },
              functionId: 'C20401',
            },
            // 0000993
            {
              title: '生徒カルテ　下書き',
              to: { name: 'C20201Draft' },
              functionId: 'C20201Draft',
            },
            {
              title: '生徒カルテ　契約',
              to: { name: 'C20201Contract' },
              functionId: 'C20201Contract',
            },
            {
              title: '生徒カルテ　保留中',
              to: { name: 'C20201Pending' },
              functionId: 'C20201Pending',
            },
            {
              title: '生徒カルテ　拒否',
              to: { name: 'C20201Denial' },
              functionId: 'C20201Denial',
            },
          ]
        },
        {
          title: '授業',
          items: [
            {
              title: '授業一覧',
              to: { name: 'C40501Browse' },
              functionId: 'C40501',
            },
            {
              title: '授業予約割当',
              to: { name: 'C40101' },
              functionId: 'C40101',
            },
            {
              title: '稼働表',
              target: '_blank',
              to: { name: 'C40201', query: { hideTemplate: 1 } },
              functionId: 'C40201',
            },
            {
              title: '授業報告書承認',
              to: { name: 'C50101Browse' },
              functionId: 'C50101',
            },
          ]
        },
        {
          title: '授業申込',
          items: [
            {
              title: 'レギュラー必要講師数',
              // to: { name: 'C40401Browse' },
              functionId: 'C40401',
              forceHidden: true,
            },
            {
              title: '授業申込',
              to: { name: 'C30101' },
              functionId: 'C30101',
            },
            {
              title: '申込制限（満席設定）',
              to: { name: 'C30201' },
              functionId: 'C30201',
            },
          ]
        },
        {
          title: '講師関連',
          items: [
            {
              title: '講師出勤確認一覧',
              to: { name: 'C40701Browse' },
              functionId: 'C40701',
            },
            {
              title: '勤務シフト',
              to: { name: 'C10201' },
              functionId: 'C10201',
            },
            {
              title: 'シフト確認',
              to: { name: 'C10301' },
              functionId: 'C10301',
            },
            {
              title: '講師情報',
              to: { name: 'C10101Browse' },
              functionId: 'C10101',
            },
          ]
        },
        {
          title: 'その他管理',
          items: [
            {
              title: 'お知らせ管理',
              to: { name: 'M00101' },
              functionId: 'M00101',
            },
            {
              title: 'レギュラー申込状況',
              to: { name: 'M00201' },
              functionId: 'M00201',
            },
            {
              title: '教室動作状況一覧',
              to: { name: 'M00501Browse' },
              functionId: 'M00501',
            },
            {
              title: 'ヘルプ',
              to: { name: 'C00103' },
              functionId: 'C00103',
            },
          ]
        },
        {
          title: 'マスタ管理',
          items: [
            {
              title: '科目管理',
              to: { name:'M20401Browse' },
              functionId: 'M20401',
            },
            {
              title: '教室管理',
              to: { name: 'M20201Browse' },
              functionId: 'M20201',
            },
            {
              title: 'ユーザー管理',
              to: { name:'M20901Browse' },
              functionId: 'M20901',
            },
            {
              title: '名称設定',
              to: { name: 'PgM20601BatchEdit' },
              functionId: 'M20601',
            },

            {
              title: 'コース管理',
              to: { name: 'M20301' },
              functionId: 'M20301',
            },
            {
              title: 'センター管理',
              to: { name: 'M20101Browse' },
              functionId: 'M20101',
            },
            {
              title: '授業開始情報管理',
              // to: { name: 'M20501' },
              functionId: 'M20501',
              forceHidden: true,
            },
            {
              title: '指導料金管理',
              to: { name: 'M30101Browse' },
              functionId: 'M30101',
            },
          ]
        },
        {
          title: 'システム設定',
          items: [
            {
              title: 'ヘルプ設定',
              to: { name: 'M21101Browse' },
              functionId: 'M21101',
            },
            {
              title: '講習予定設定',
              to: { name: 'M20801Browse' },
              functionId: 'M20801',
            },
            {
              title: '通知メール設定',
              to: { name: 'M20701Browse' },
              functionId: 'M20701',
            },
            {
              title: 'カレンダー・休業日設定',
              to: { name: 'M21001Browse' },
              functionId: 'M21001',
            },
          ]
        },
        {
          title: '',
          items: [
            // === 講師 === //
            {
              title: '本日の予定',
              to: { name: 'C11101' },
              functionId: 'C11101',
            },
            {
              title: '今後の予定',
              to: { name: 'C11201' },
              functionId: 'C11201',
            },
            {
              title: '勤務シフト',
              to: { name: 'C10201Teacher',
                params: {
                  teacher_no: this.getUser.teacher_no
                }
              },
              functionId: 'C10201',
            },
            {
              title: '授業報告書一覧',
              to: { name: 'C50101TeacherBrowse' },
              functionId: 'C50101',
            },
            // === 生徒 === //
            {
              title: '本日の予定',
              to: { name: 'C21101' },
            },
            {
              title: '今後の予定・授業振替',
              to: { name: 'C21201' },
            },
            {
              title: '追加授業申込・講習申込',
              to: { name: 'C30101Student' },
            },
            {
              title: '授業履歴一覧',
              to: { name: 'C40501Browse' },
              functionId: 'C40501',
            },
            {
              title: 'お知らせ',
              to: { name: 'C00101' },
            },
            {
              title: 'ヘルプ',
              to: { name: 'C00103' },
              functionId: 'C00103',
            },
            {
              title: '講師情報',
              to: { name: 'C10101Edit',
                params:{
                  teacher_id:this.getUser.user_id
                }
              },
              functionId: 'C10101',
            },
          ]
        },
        {
          title: 'Section_1',
          debug: true,
          items: [
            {
              title: 'Child_1.1',
              icon: 'mdi-view-dashboard',
              to: { name: '' },
              child: [
                {
                  title: 'Grandchild_1.1.1',
                  icon: 'mdi-view-dashboard',
                  to: { name: '' },
                }
              ]
            }
          ]
        },
      ]
    },
    filtedSidebarList(){
      // use value from database table
      if(this.isStudent){
        return [{
          title: '',
          items: [
            ...this.menu
              .filter(item => item.show !== false)
              .map(item => {
                return {
                  title: item.mmenu_name,
                  to: { name: item.function_id },
                }
              }),
          ]
        }]
      }

      if (!this.getUserAuthorityFunctionIDs || this.getUserAuthorityFunctionIDs.length === 0) return []
      let filteredList = {}
      this.mainSidebarList.forEach(section => {
        section?.items.forEach(item => {
          if (item.show === false) return

          const targetMenuItem = this.menu.find(menuItem => menuItem.function_id === item.functionId)
          let flag= false
          if (targetMenuItem)
            flag = true
          if(item.forceVisible) {
            flag = true
          } else if(item.forceHidden) {
            flag = false
          }
          if(flag){
            if (!filteredList[section.title])
              filteredList[section.title] = {
                ...section,
                items: []
              }
            // Remove disabled route, Should be deprecated in future
            if (this.getUserDisabledRouteNames.some((name) => item?.to?.name.includes(name))) delete item.to
            filteredList[section.title].items.push({
              ...item,
              // title: item.title+"-"+targetMenuItem.mmenu_name,
            })
          }
        })
      });
      // Only admin show section
      if (this.getUser.user_type_code < 400) {
        filteredList = Object.fromEntries(Object.entries(filteredList).filter(([key]) => key === ""))
      } else {
        filteredList = Object.fromEntries(Object.entries(filteredList).filter(([key]) => key !== ""))
      }
      return Object.values(filteredList)
    }
  },
  methods:{
    post_beforeRouteEnter (to, _from, next) {
      next((vm) => {
        if(vm.isStudent){
        // get current route name
          const currentRouteName = vm.$route.name
          // find the menu item that matches the current route name
          const menuItem = vm.menu.find(item => currentRouteName.startsWith(item.function_id))
          // if found, return the menu name
          if (menuItem) {
            vm.SET_APP_HEADER_TITLE(menuItem.mmenu_name)
          }
        }
      })
    }
  }
}
</script>

<style>

</style>
